import { Badge, Button } from '@iveco-ti/iveco-ds'
import { Filter } from 'lucide-react'
import { useTranslation } from 'react-i18next'

type FilterButtonProps = {
  open: () => void
  filters: number
}

export function FilterButton({ open, filters }: FilterButtonProps) {
  const { t } = useTranslation('common')

  return (
    <Button.Root onClick={open} size="sm" variant="secondary" color="brand">
      <Button.Icon icon={Filter} />

      {t('components.button_filter.label')}

      {filters > 0 && (
        <Badge.Root size="sm" color="brand">
          {filters}
        </Badge.Root>
      )}
    </Button.Root>
  )
}
